// src/components/routes/RequireAdmin.js
import React from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import { Navigate, Outlet, useLocation, Link as RouterLink } from "react-router-dom";
import useRole from "../../auth/useRole";
import { useAuth } from "../../auth/AuthContext";
import useStore from "../../store/useStore";
import { ACCOUNT_TYPES } from "../../services/profileService";

export default function RequireAdmin() {
  const { isAdmin } = useRole();
  const loc = useLocation();
  const { user, loading } = useAuth() || {};
  const { userProfile } = useStore();
  const hasAccountType = Object.values(ACCOUNT_TYPES).includes(userProfile?.accountType);
  const requestedPath = `${loc.pathname}${loc.search || ""}`;

  if (loading) return null;
  if (!user) {
    return <Navigate to="/signin" state={{ from: loc }} replace />;
  }
  if (isAdmin) return <Outlet />;
  if (!hasAccountType) {
    return <Navigate to={`/account-type?next=${encodeURIComponent(requestedPath)}`} state={{ from: loc }} replace />;
  }

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 160px)",
        display: "grid",
        placeItems: "center",
        px: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 4,
          border: 1,
          borderColor: "divider",
          borderRadius: 1,
          width: "100%",
          maxWidth: 460,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" sx={{ mb: 1 }}>Coming Soon</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          This area is still being prepared and is not publicly available yet.
        </Typography>
        <Box>
          <Button
            variant="contained"
            component={RouterLink}
            to={`/?from=${encodeURIComponent(loc.pathname + loc.search)}`}
          >
            Back to Home
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
